import {EmployeeRoleCd} from '../';
import {EnumHelper} from './enum-helper';

export class EmployeeRoleCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in EmployeeRoleCd ) {
      this._values.push(EmployeeRoleCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): EmployeeRoleCd {

    for ( const obj in EmployeeRoleCd ) {
      if (EmployeeRoleCd[obj] === value){
        return EmployeeRoleCd[obj] as EmployeeRoleCd;
      }
    }
  }
}

const EmployeeRoleCdHelper = new EmployeeRoleCdHelperEnumHelperClass();
export default EmployeeRoleCdHelper;
